
import {Component, OnInit} from "@angular/core";
import {BreadcrumbService} from "xng-breadcrumb";

@Component({
    selector: 'dp-cirf-home',
    templateUrl: './cirf-home.component.html'
})
export class CirfHomeComponent implements OnInit {
    constructor( private breadcrumbService: BreadcrumbService) {

    }

    ngOnInit() {
        this.breadcrumbService.set('@MS', 'Matter Summary');
    }


}